<template>
  <div class="overview-area">
    <div class="title">
      <div class="big-title">生态元核算分析系统</div>
    </div>
    <p>双碳目标提出后，为方便相关政府部门全面了解区域内生态环境、能源和碳排放总体情况，腾景数研构建了以生态指标为主，囊括环境、碳汇、能源、碳排放和经济指标的专题数据库，选取若干重点指标，关联全国、省、市、区县多个行政层级，全面汇集展示相关指标数据，具有以下功能。</p>
    <p>
      <strong>（1）区域数据总览：鸟瞰全局</strong>
    </p>
    <p>从总量角度，综合展示全国、省、市、区县多个行政层级的生态、环境、碳汇、碳排放和能源指标时间序列数据，以及按人均、地均或单位GDP口径对应的指标数据，使主政者鸟瞰生态环境全局，一目了然便捷地获取关键数据信息。</p>
    <p class="img">
      <img src="../../assets/img/28.png" alt />
    </p>
    <p>
      <strong>（2）区域数据分析：洞察结构症结</strong>
    </p>
    <p>从结构角度，联动分析展示生态、环境、碳汇、碳排放、能源总量指标背后的构成和比例关系及其动态变化过程，揭示相关指标数据背后复杂的结构关系，帮助主政者洞察生态环境领域强项和短板背后的结构症结所在，有针对性地精准施策。</p>
    <p class="img">
      <img src="../../assets/img/29.png" alt />
    </p>
    <p>
      <strong>（3）全面多维数据对比：全面精准定位</strong>
    </p>
    <p>从总量和结构两个维度，对比展示多层级区域间生态、环境、碳汇、碳排放、能源等重点指标的绝对值、占比、增量、增速排名变化，系统支持自由切换比较方面、数据维度以及时间节点，可根据需要展示不同方面、不同维度、不同时间的多指标对比情况与排名，帮助主政者全方位、多层次、多视角深入了解本地区在不同时间、不同行政层级中所处的位置和排名。</p>
    <p class="img">
      <img src="../../assets/img/30.png" alt />
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.overview-area {
  background: #fff;
  margin: 20px 0 0 20px;
  padding: 20px;
  box-sizing: border-box;
  .title {
    color: #333399;
    text-align: center;
    font-size: 24px;
    padding: 30px 0;
    .big-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }
  }
  p {
    text-indent: 32px;
    img {
      height: 300px;
      padding-bottom: 20px;
    }
    &.img {
      text-align: center;
    }
  }
}
</style>